<div class="row">
  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Inputs</h1>
    <h4>
      <a
        href="https://material.angular.io/components/input/examples"
        title="Material Input"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div class="mb-3">
      <mat-form-field class="w-100">
        <mat-label>Some input</mat-label>
        <input
          type="text"
          matInput />
      </mat-form-field>
    </div>

    <div class="mb-3">
      <form [formGroup]="emailForm">
        <mat-form-field class="w-100">
          <mat-label>Email</mat-label>
          <input
            formControlName="email"
            matInput
            placeholder="Ex. pat@example.com" />
          <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">Please enter a valid email address</mat-error>
          <mat-error *ngIf="email.hasError('required')">Email is <strong>required</strong></mat-error>
        </mat-form-field>
      </form>
    </div>

    <div class="mb-3">
      <mat-form-field class="w-100">
        <mat-label>Message</mat-label>
        <input
          matInput
          maxlength="256"
          placeholder="Ex. I need help with..."
          #message />
        <mat-hint align="start"><strong>Don't disclose personal info</strong> </mat-hint>
        <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="w-100">
        <mat-label>Telephone</mat-label>
        <span matPrefix>+1 &nbsp;</span>
        <input
          type="tel"
          matInput
          placeholder="555-555-1234" />
        <span matSuffix>(suffix)</span>
      </mat-form-field>
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Textarea</h1>
    <h4>
      <a
        href="https://material.angular.io/components/input/overview"
        title="Material Input & Textarea"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-form-field class="w-100">
      <mat-label>Leave a comment</mat-label>
      <textarea
        matInput
        placeholder="Ex. It makes me feel..."></textarea>
    </mat-form-field>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Select</h1>
    <h4>
      <a
        href="https://material.angular.io/components/select/examples"
        title="Material Select"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-form-field class="w-100">
      <mat-label>Choose an option</mat-label>
      <mat-select>
        <mat-option value="option1">Option 1</mat-option>
        <mat-option
          value="option2"
          disabled
          >Option 2 (disabled)</mat-option
        >
        <mat-option value="option3">Option 3</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Radio / Slider</h1>
    <h4>
      <a
        href="https://material.angular.io/components/radio/overview"
        title="Material Radio"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-radio-group aria-label="Select an option">
      <mat-radio-button
        class="d-block"
        value="1"
        >Option 1 (accent)</mat-radio-button
      >
      <mat-radio-button
        class="d-block"
        value="2"
        color="primary"
        >Option 2 (primary)</mat-radio-button
      >
      <mat-radio-button
        class="d-block"
        value="2"
        color="warn"
        >Option 2 (warn)</mat-radio-button
      >
    </mat-radio-group>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Checkbox</h1>
    <h4>
      <a
        href="https://material.angular.io/components/checkbox/examples"
        title="Material Checkbox"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-checkbox class="d-block">Do you agree ?</mat-checkbox>
    <mat-checkbox
      class="d-block"
      color="primary"
      >Do you agree ? (primary)</mat-checkbox
    >
    <mat-checkbox
      class="d-block"
      color="warn"
      >Do you agree ? (warn)</mat-checkbox
    >
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Date picker</h1>
    <h4>
      <a
        href="https://material.angular.io/components/datepicker/examples"
        title="Material Daepicker"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-form-field class="example-full-width">
      <input
        matInput
        placeholder="Choose a date"
        [matDatepicker]="picker" />
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <button
      mat-raised-button
      (click)="picker.open()">
      Open
    </button>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h1>Toggle</h1>
    <h4>
      <a
        href="https://material.angular.io/components/slide-toggle/examples"
        title="Material Slider"
        target="_blank"
        >Doc</a
      >
    </h4>

    <mat-slide-toggle class="d-block">Slide me!</mat-slide-toggle>
    <mat-slide-toggle
      class="d-block"
      color="primary"
      >Slide me! (primary)</mat-slide-toggle
    >
    <mat-slide-toggle
      class="d-block"
      color="warn"
      >Slide me! (warn)</mat-slide-toggle
    >
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h1>Mat form field without underline</h1>
    <p>Suitable for example for slider</p>
    <code>Add css class 'sh-no-mat-form-field-underline' to mat-form-field</code>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h2>Input</h2>

    <mat-form-field class="sh-no-mat-form-field-underline">
      <mat-label>Some input</mat-label>
      <input
        type="text"
        matInput />
    </mat-form-field>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-4 col-lg-3">
    <h2>Slider</h2>

    <mat-form-field
      class="sh-no-mat-form-field-underline"
      appearance="standard"
      floatLabel="always">
      <mat-label>Label for slider</mat-label>

      <mat-slide-toggle class="mx-2"></mat-slide-toggle>
      <textarea
        hidden
        matInput></textarea>
    </mat-form-field>
  </div>
</div>
